
<br />

<div class="oroDefault">

  <br />
  <br />

  <h2>
    <b >Returns and Refunds Policy</b>
  </h2>

  <br />
  
  <div class="oroHub oroContent">

    <p>Thank you for shopping at Official Records Online.</p>
    <p class="oroTextAlignLeft">Please read this policy carefully. This is the Return and Refund Policy of Official Records Online. This Return and Refund Policy is licensed by <a href="https://termsfeed.com" rel="nofollow">TermsFeed Generator</a> to Official Records Online.</p>


    <h2>Digital products</h2>
    <p class="oroTextAlignLeft">We do not issue refunds for digital products once the order is confirmed and the product is sent.</p>
    <p class="oroTextAlignLeft">We recommend contacting us for assistance if you experience any issues receiving or downloading our products.</p>

    <h2>Contact us</h2>
    <p class="oroTextAlignLeft">If you have any questions about our Returns and Refunds Policy, please <a [routerLink]='["/contact-us"]' tabindex="-1">contact us</a>.</p>

</div>

  <p>
    <br />
    <button class="btn btn-primary" (click)="gotoHub()" [disabled]="this.isDisabled" title="Go Back">Back</button>
  </p>
</div>
<br />